import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_grievance_handling_and_dispute_resolution_procedures_access'

export const dataPointDefinition = {
  retracedId: 'are_grievance_handling_and_dispute_resolution_procedures_access',
  name: 'Are grievance handling and dispute resolution procedures accessible in different languages?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'GRIEVANCE_HANDLING_AND_DISPUTE_RESOLUTION_PROCEDURES_ARE_ACCESS',
      text: 'Grievance handling and dispute resolution procedures are accessible in all languages spoken at the facility',
      externalIds: [
        {
          id: 'gr-1--2-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'GRIEVANCE_HANDLING_AND_DISPUTE_RESOLUTION_PROCEDURES_ARE_ACCESS_NOT_ALL',
      text: 'Grievance handling and dispute resolution procedures are accessible in some languages spoken at the facility, but not all',
      externalIds: [
        {
          id: 'gr-1--2-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'Please describe which languages are not available in grievance handling and dispute resolution procedures:',
        externalIds: [
          {
            id: 'gr-1--2-2f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'GRIEVANCE_HANDLING_AND_DISPUTE_RESOLUTION_PROCEDURES_ARE_ACCESS',
                'GRIEVANCE_HANDLING_AND_DISPUTE_RESOLUTION_PROCEDURES_ARE_ACCESS_NOT_ALL',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-gri-3',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12900,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
